import { combineReducers } from '@reduxjs/toolkit';
import { fork } from 'redux-saga/effects';
import bestFriends, { bestFriendsSaga } from './bestFriends';
import catalog, { catalogSaga } from './catalog';
import chat, { chatSaga } from './chat';
import dream, { dreamSaga } from './dream';
import fortune, { fortuneSaga } from './fortune';
import lifeSupports, { LifeSupportsSaga } from './lifeSupports';
import myDesign, { myDesignSaga } from './myDesign';
import newspaper, { newspaperSaga } from './newspaper';
import notification, { notificationSaga } from './notification';
import passport, { passportSaga } from './passport';
import reaction, { reactionSaga } from './reaction';
import resort, { ResortSaga } from './resort';
import user, { userSaga } from './user';

const rootReducer = combineReducers({
  passport,
  bestFriends,
  chat,
  myDesign,
  user,
  notification,
  dream,
  reaction,
  catalog,
  fortune,
  resort,
  lifeSupports,
  newspaper
});

export default rootReducer;

export type RootState = ReturnType<typeof rootReducer>;

export function* rootSaga() {
  yield fork(passportSaga);
  yield fork(bestFriendsSaga);
  yield fork(chatSaga);
  yield fork(myDesignSaga);
  yield fork(userSaga);
  yield fork(notificationSaga);
  yield fork(dreamSaga);
  yield fork(reactionSaga);
  yield fork(catalogSaga);
  yield fork(fortuneSaga);
  yield fork(ResortSaga);
  yield fork(LifeSupportsSaga);
  yield fork(newspaperSaga);
}
